import { render, staticRenderFns } from "./QuickReview.vue?vue&type=template&id=7855bb58&"
import script from "./QuickReview.vue?vue&type=script&lang=js&"
export * from "./QuickReview.vue?vue&type=script&lang=js&"
import style0 from "./QuickReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports